export default "__VITE_ASSET__C9GWMde$__"